<flx-modal
  [dismissible]="true"
  (dismiss)="hideModal.emit()"
  class="flx-ds large h-full"
  data-testid="workflow-instance-details-modal"
>
  <div
    class="flx-modal-title flex gap-2 items-center justify-center"
    flxModalHeaderTitle
  >
    <span>{{ workflowName() }}</span>
    <p-tag
      [value]="status()"
      [severity]="instanceStatusTagTypeMap[status()?.toLowerCase()] || 'info'"
      class="flx-tag inline py-1.5"
    />
  </div>
  <div class="flx-modal-body pt-3">
    <flx-workflow-run-instance class="flex flex-col h-full"></flx-workflow-run-instance>
  </div>
</flx-modal>
